import React, { Component } from "react";
import GolfStatusLogUpdateSlot from "./GolfStatusLogUpdateSlot";

class GolfStatusLogUpdate extends Component {
  constructor(props) {
    super(props);
  }
  render() {

    let new_datestring = new Date(this.props.golfstatusupdate.timestamp).toLocaleString("en-GB").replace('/','-').replace('/','-');

    return (
      <li>
        <h4>{new_datestring}</h4>
        <table className="table table-striped table-sm">
          <thead className="thead-dark">
            <tr>
                <th>User</th>
                <th>Zone</th>
                <th>FL</th>
                <th>Start Hour</th>
                <th>Start Minutes</th>
                <th>End Hour</th>
                <th>End Minutes</th>
            </tr>
          </thead>
          <tbody>
            {this.props.golfstatusupdate.golflist.map(zone => {
              console.log("We are starting mapping golflist")
              if(zone.slots.length>0){
                console.log("More than 0 slots in the zone")
                return (zone.slots.map((slot,index) => {
		    console.log("the index is: "+index)
                    return(<GolfStatusLogUpdateSlot
                                      key={this.props.golfstatusupdate.timestamp+zone.name}
                                      zone={zone}
                                      user={this.props.golfstatusupdate.user}
                                      counter={index}
                                      slot={slot}
                                      
                    />)

                  })
		)

              }
            })}
            
          </tbody>
        </table>
      </li>
    );
  }
}

export default GolfStatusLogUpdate;
